<template>
<div>
	<div class="infomationTable">
		<table class="table">
		    <tr>
			    <th>序号</th>
			    <th>开始时间</th>
			    <th>截止时间</th>
			    <th>单位名称</th>
			    <th>任职职务</th>
			    <th>负责工作及业绩</th>
			    <th>离职原因</th>
			    <th>证明人电话</th>
			    <!-- <th>附件（上传简历）</th> -->
			    <th>操作</th>
		    </tr>
		    <tr v-for="(item,index) in formList">
		        <td>
		        	<div class="label">序号</div>
		        	{{index+1}}
		        </td>
		        <td>
		        	<div class="label">开始时间</div>
		        	{{item.startTime}}
		        </td>
		        <td>
		        	<div class="label">截止时间</div>
		        	{{item.soFarStatus=="Y"?'至今':item.endTime}}
		        </td>
		        <td>
		        	<div class="label">单位名称</div>
		        	{{item.unitName}}
		        </td>
		        <td>
		        	<div class="label">任职职务</div>
		        	{{item.position}}
		        </td>
		        <td>
		        	<div class="label">负责工作及业绩</div>
		        	{{item.workContent}}
		        </td>
		        <td>
		        	<div class="label">离职原因</div>
		        	{{item.reason}}
		        </td>
		         <td>
		        	<div class="label">证明人手机号</div>
		        	{{item.phone}}
		        </td>
		        <!-- <td>
		        	<div class="label">附件（上传简历）</div>
		        	<div class="fjName" :title="item.file">{{item.file}}</div>
		        </td> -->
		      	<td>
		      		<div class="label">操作</div>
		      		<div class="edit" @click="edit(item.id)">编辑</div>
		      	</td>
		    </tr>
		</table>
	</div>
	
	<!-- 添加按钮 -->
	<div class="addBtn" @click="add"></div>
	
	<!-- 编辑、新增的弹窗 -->
	<div class="infomationAddEdit" v-if="popShow">
		<div class="mask"></div>
		<div class="form">
			<div class="close" @click="cancel"></div>
			<div class="tit f-16 fb">
				<template v-if="addOrEdit==1">
					新增
				</template>
				<template v-if="addOrEdit==2">
					编辑
				</template>	
			</div>
	        <div class="item cf">
	        	<div class="name fl"><span>*</span>开始时间</div>
	        	<div class="ovh text">
	        		<el-date-picker
			            v-model="popData.startTime"
			            value-format="yyyy-MM-dd"
			            placeholder="请选择开始时间"
			            :picker-options="startPickerOptions">
			        </el-date-picker>
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>截止时间</div>
	        	<div class="ovh">
	        		<div class="text">
		        		<el-date-picker
				            v-model="popData.endTime"
				            value-format="yyyy-MM-dd"
				            placeholder="请选择截止时间"
				            :picker-options="endPickerOptions">
				        </el-date-picker>
			        </div>
			        <div class="zhijin">
						<el-checkbox v-model="checked">至今</el-checkbox>
			        </div>
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>单位名称</div>
	        	<div class="ovh text">
					<input type="text" v-model="popData.unitName" name="unitName" placeholder="请填写单位名称">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>任职职务</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.position" name="position" placeholder="请填写任职职务">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>负责工作及业绩</div>
	        	<div class="ovh text">
	        		<!-- <input type="text" v-model="popData.workContent" name="workContent" placeholder="请填写负责工作及业绩"> -->
	        		<textarea v-model="popData.workContent" placeholder="请填写负责工作及业绩"></textarea>
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>离职原因</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.reason" name="reason" placeholder="请填写离职原因">
				</div>
			</div>
			<div class="item cf">
	        	<div class="name fl"><span>*</span>证明人手机号</div>
	        	<div class="ovh text">
	        		<input type="text" v-model="popData.phone" name="phone" placeholder="请填写证明人手机号">
				</div>
			</div>
			
			<!-- <div class="item cf">
	        	<div class="name fl">上传附件</div>
	        	<div class="ovh">
	        		<el-upload
			          class="upload-demo"
			          :action="uploadFileUrl"
			          :headers="headers"
			          :show-file-list="true"
			          :on-success="(res,file)=>{return handleSuccess(res,file)}"
			          :on-remove="(res,file)=>{return handleRemove(res,file)}"
			          :multiple="false"
			          :file-list="popData.file"
			          :before-upload="uploadFun">
			            <span class="fileInput" v-if="popData.file==''||popData.file==null">点击上传</span>
			        </el-upload>
				</div>
			</div> -->

	      	<div class="btnBox">
				<div class="btn btn1" @click="save">保存</div>
				<div class="btn btn2" @click="cancel">取消</div>
	      	</div>
		</div>
	</div>
</div>
</template>
<script>
import { urlHead } from '@/utils/http'
import { 
  careerList,
  careerAdd,
  careerEdit,
  careerDelete,
  careerQueryById
} from "@/api/tableapi";

export default {
	name: 'tablecareer',
	props:{
		isshow: {
	      	type: Boolean,
  			default: {}
	    }
	},
	watch: {
	    isshow: {
	      immediate: true,
	      handler(newval,oldval) {
	        if (newval) {
	        	this.initData()
	        }
	      }
	    },
	},
	data(){
		return{
			uploadFileUrl:urlHead+'user-api/common/upload',
		    headers: {
		       'X-Access-Token':window.sessionStorage.getItem('token'), //headers属性中添加token，这个属性是el-upload自带的用来设置上传请求头部
		    },
		    formList:[],
		    addOrEdit:1,   //1是新增2是编辑
		    popData:{
		    	startTime:'',
		    	endTime:'',
		    	unitName:'',
		    	position:'',
		    	workContent:'',
		    	reason:'',
		    	phone:'',
		    	file:[],
		    	soFarStatus:null
		    },
		    popShow:false,

		    xueliOptions:[],

			checked:false
		}
	},
	computed: {
	    startPickerOptions() {
	      return {
	        disabledDate: time => {
	          return this.popData.endTime ? time.getTime() > new Date(this.popData.endTime).getTime() : false;
	        }
	      };
	    },
	    endPickerOptions() {
	      return {
	        disabledDate: time => {
	          return this.popData.startTime ? time.getTime() < new Date(this.popData.startTime).getTime() : false;
	        }
	      };
	    }
	},
	created(){
		this.initData()
	},
  	methods:{
  		//获取当前表格的数据
  		initData(){
  			let that=this
  			careerList("").then(res=>{
              if (res.success) {
              	let list=res.result.records
              	list.forEach((item,index)=>{
              		if(item.file!=''&&item.file!=null){
	              		let nameArr=item.file.split("/")
			          	let ind = nameArr.length - 1
			          	item.file=nameArr[ind]	
		          	}
              	})                
                that.formList=list
              }
            })
        },

        //添加
	    add(){
	    	let that=this
	    	that.addOrEdit=1
	    	that.checked=false
	    	that.popData={
		    	startTime:'',
		    	endTime:'',
		    	unitName:'',
		    	position:'',
		    	workContent:'',
		    	reason:'',
		    	phone:'',
		    	file:[],
		    	soFarStatus:null
		    }

		    that.popShow=true
	    },

	    //编辑
	    edit(id){
	    	let that=this
	    	careerQueryById(id).then(res=>{
		        //console.log(res)
		        if(res.success){
		          that.addOrEdit=2
		          if (res.result.file==null||res.result.file=='') {
		          	res.result.file=[]
		          }else{
		          	let nameArr=res.result.file.split("/")
		          	let ind = nameArr.length - 1
		          	res.result.file=[{
		          		name: nameArr[ind], 
		          		url: res.file
		          	}]
		          }

		          if(res.result.startTime!=''&&res.result.startTime!=null){
		            let startTime=res.result.startTime
		            res.result.startTime=startTime.split(" ")[0]
		          }

		          if(res.result.endTime!=''&&res.result.endTime!=null){
		            let endTime=res.result.endTime
		            res.result.endTime=endTime.split(" ")[0]
		          }

		          if (res.result.soFarStatus=="Y") {
		          	that.checked=true
		          }else{
		          	that.checked=false
		          }

		          that.popData=res.result

		          that.popShow=true
		        }else{
		          that.$message.error(res.message)
		          return false
		        }
		    })
	    },

	    handleSuccess(res,file) {
		    let that=this
		    that.popData.file=[{name:file.name, url:res.result}]
	    },
	    //移除
	    handleRemove(res,file) { 
	    	let that=this
	    	that.popData.file=[]
	    },

	    //上传前格式校验
	    uploadFun(file){
	      let that=this
	      //console.log(file.type,"file.type")
	      const isJPG = file.type === 'image/jpeg' || file.type==='image/png' || file.type==='image/jpg' || file.type==='application/pdf' || file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/vnd.ms-powerpoint' || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
	      const isLt50M = file.size / 1024 / 1024 < 50;
	      //word excel ppt
	      if (!isJPG) {
	        that.$message.error('只能上传pdf、图片、word、excel、ppt!');
	      }
	      if (!isLt50M) {
	        that.$message.error('上传头像图片大小不能超过 50MB!');
	      }
	      return isJPG && isLt50M;
	    },

	    save(){
	    	let that=this
	    	let regTel = new RegExp("^1\\d{10}$");

		    //验证，表格结构数据中有必填和校验正则
		    if (that.popData.startTime==''||that.popData.startTime==null) {
		    	that.$message.error('请选择开始时间!');
		    	return false
		    }

		    if (that.checked) {
		    	that.popData.soFarStatus="Y"
		    }else{
		    	that.popData.soFarStatus=""
			    if (that.popData.endTime==''||that.popData.endTime==null) {
			    	that.$message.error('请选择截止时间!');
			    	return false
			    }
		    }

		    if (that.popData.unitName==''||that.popData.unitName==null) {
		    	that.$message.error('请填写单位名称！');
		    	return false
		    }

		    if (that.popData.position==''||that.popData.position==null) {
		    	that.$message.error('请填写任职职务！');
		    	return false
		    }

		    if (that.popData.workContent==''||that.popData.workContent==null) {
		    	that.$message.error('请填写负责工作及业绩！');
		    	return false
		    }

		    if (that.popData.reason==''||that.popData.reason==null) {
		    	that.$message.error('请填写离职原因！');
		    	return false
		    }

		    if (that.popData.phone==''||that.popData.phone==null) {
		    	that.$message.error('请填写证明人手机号！');
		    	return false
		    }
		    if(!regTel.test(that.popData.phone)){
		    	that.$message.error('手机号格式错误！');
		    	return false
		    }

		    //通过验证
		    that.popData.startTime += " 00:00:00"
		    if (!that.checked) {
		    	that.popData.endTime += ' 00:00:00'
		    }

		    let popData={...that.popData}
		    
		    if(popData.file!=''&&popData.file!=null){
		    	popData.file=popData.file[0].url
		    }else{
		    	popData.file=""
		    }

		    //添加
		    if (that.addOrEdit==1) {
		    	careerAdd(popData).then(res=>{
	              if (res.success) {
	              	that.initData()            
	                that.$message.success('添加成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
		    //编辑
		    if (that.addOrEdit==2) {
		    	careerEdit(popData).then(res=>{
	              if (res.success) { 
	              	that.initData()              
	                that.$message.success('编辑成功');
	                that.popShow=false
	              }else{
	              	that.$message.error(res.message);
	              }
	            })
		    }
	    },

	    cancel(){
	    	let that=this
	    	that.popShow=false
	    }
  	}
}
</script>





// WEBPACK FOOTER //
// src/components/global/tablecareer/index.vue